import React, { useContext } from "react"
import { Route, Redirect } from "react-router-dom";
import { ClaimContextStore } from "../../context/ClaimContext";
import { SessionService } from "../../services/SessionService";


export const ClaimRouteGuard = ({children, ...rest}) => {
    const claimContext = useContext(ClaimContextStore)

    return (
        <Route
          {...rest}
          render={({ location }) =>
              SessionService.isLoggedIn() && !!claimContext.selected_policy ? 
              children
              : 
              <Redirect
                to={{
                  pathname: SessionService.isLoggedIn() ? "/claim/process/policy" : '/claim',
                  state: { from: location }
                }}
              />
          }
        />
      );
}